

const mutations = {
  SET_EQUITIES_BREAKDOWN(state, payload) {
    payload = payload || {};
    state.equitiesBreakdown = {
      equityBreakdownChart: payload.equityBreakdownChart,
      holdings: {
        data: payload.holdings && payload.holdings.data && filterDataForBlueBar(payload.holdings.data),
        asOfDate: payload.holdings && payload.holdings.asOfDate
      },
      industries: {
        data: payload.industries && payload.industries.data && filterDataForBlueBar(payload.industries.data),
        asOfDate: payload.industries && payload.industries.asOfDate
      },
      sectors: {
        data: payload.sectors && payload.sectors.data,
        asOfDate: payload.sectors && payload.sectors.asOfDate
      }
    };
  }
};

const getters = {
  getEQbreakdown: state => state.equitiesBreakdown
};
function filterDataForBlueBar(array) {
  const returnArray = [];
  array.forEach(item => {
    if (item.name && item.value) {
      returnArray.push({
        SubTypeName: item.name,
        DataValue: item.value
      });
    }
  });
  return returnArray;
}

const state = {
  equitiesBreakdown: {
    holdings: {
      data: [],
      asOfDate: ''
    },
    industries: {
      data: [],
      asOfDate: ''
    },
    sectors: {
      data: [],
      asOfDate: ''
    },
    equityBreakdownChart: ''
  }
};

export default {
  state,
  getters,
  mutations
};
